import type { CollectionKey, RowDiff } from "./profile-merge-types";

// What a taken collection row must carry before the commit can build its write: at least one of these review fields
// non-blank. A CREATE needs it for every section with a rule; an UPDATE only where its mutation requires the field,
// because an omitted field keeps its saved value. An education's field of study and start date are optional
// (genesis V0166): it names a field of study, an institution or a degree, and an update may leave all three as saved.
const CREATE_CONTENT_FIELDS: Partial<Record<CollectionKey, readonly string[]>> = {
  experiences: ["title"],
  educations: ["fieldOfStudy", "institution", "degree"],
  certificates: ["name"],
};
const UPDATE_CONTENT_FIELDS: Partial<Record<CollectionKey, readonly string[]>> = {
  experiences: ["title"],
  certificates: ["name"],
};

/** Whether a row read through `value` carries what its CREATE or UPDATE needs; sections without a rule always do. */
export function rowBuildable(
  section: CollectionKey,
  write: "create" | "update",
  value: (field: string) => string | null | undefined,
): boolean {
  const fields = (write === "create" ? CREATE_CONTENT_FIELDS : UPDATE_CONTENT_FIELDS)[section];
  return !fields || fields.some((field) => (value(field) ?? "").trim() !== "");
}

/** The write a taken row turns into: a CREATE for an ADD (or a row without a saved counterpart), else an UPDATE. */
export function rowWrite(row: Pick<RowDiff, "action" | "existingRowId">): "create" | "update" {
  return row.action === "ADD" || row.existingRowId === null ? "create" : "update";
}
